export default class ErrorCodeResponseError extends Error {
    errorCode: number;

    constructor(errorCode: number, message = '') {
        super(message);
        this.name = 'ErrorCodeResponseError';
        this.errorCode = errorCode;

        Object.setPrototypeOf(this, ErrorCodeResponseError.prototype);
    }
}
